import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';
import { withRouter } from 'react-router-dom';
import {
  CONTENTFUL_NEWS_PAGE_SIZE,
  fetchAllNewsItemsPages,
  shouldPaginateNewsItems,
} from '../../utils/contentfulNewsPagination';
import { filterPublicGenericPageWithNews } from '../../utils/publicRoutes';

export default function genericWithData(WrappedComponent, options = {}) {
	const QUERY = gql `query genericPageQuery($newsSkip: Int, $newsLimit: Int) {
				  newsItems(skip: $newsSkip, limit: $newsLimit) {
						visibilityValue
			            newsTitle
			            route
			            videoLink
			            date
			            description
			            department{
							visibilityValue
			            	name
			            	route
			            }
			              image {
							    title
							    description
							    url
							}
					}
					_newsItemsMeta {
						count
					}
					  genericPageWithNews {
					    route
					    backgroundHeader
					    backgroundDescription
					    pageDescription
					    quickLinksHeader
					    popularDocumentsHeader
					    newsAndInformationHeader
					    fileAndDocumentsHeader
					    backgroundImage {
					      title
					      description
					      url
					    }
					    filesAndDocuments {
						  visibilityValue
					      department
					      title
					      fileUpload {
			                  title
			                  description
			                  url
		                	}
		                	uploadDate
					    }
					    quickLinks {
					      route
					      text
					    }
					    popularDocuments {
					      fileLink{
			                  title
			                  description
			                  url
			                }
					      text
					    }
					    executive {
					      name
					      title
					      picture {
					        title
					        description
					        url
					      }
					    }
						department {
							route
							name
							visibilityValue
						}
					  }
					  feedbackComponents {
					    feedbackHeader
					    feedbackDescription
					    feedbackCtAtext
					    feedbackImage {
					      title
					      description
					      url
					    }
					  }

					  headerFooterComponents {
					    footerHeader
					    footerBody
					    copyrightHolder
					    primaryNavigationLinks{
					      route
					      text
					    }
						seasonalPrimaryNavigationLinks{
						  route
						  text
						}
					    footerLinks{
					      route
					      text
					    }
					    seasonalFooterLinks{
					      route
					      text
					    }
					    secondaryFooterLinks {
					      route
					      text
					    }
					    footerLogo {
					      title
					      description
					      url
					    }
					  }
					  exploreComponents {
					    isNotDisplayed
					    exploreTitle
					    exploreTile {
					    backgroundImage {
						        title
						        description
						        url
						      }
					      route
					      title
					      ctaText
					    }
					  }
					    globalSites{
					    	feedback {
						 feedbackHeader
						 feedbackDescription
						 feedbackCtAtext
					   feedbackImage {
						 title
						 description
						 url
						}
					}
				  mainNavigation {
						 footerHeader
						 footerBody
						 copyrightHolder
						 primaryNavigationLinks{
							 route
							 text
						 }
						 seasonalPrimaryNavigationLinks{
						  route
						  text
						 }
						 footerLinks{
						   route
						   text
						 }
					     seasonalFooterLinks{
					      route
					      text
					     }
						 secondaryFooterLinks {
						   route
						   text
						 }
						 footerLogo {
						   title
						   description
						   url
						 }
				   }
						    cubsLogo {
						      title
						      description
						      url
						    }
						  }
					}
	  `;

	const HOC = class extends Component {
		componentDidMount() {
			this.loadRemainingNewsItems();
		}

		componentDidUpdate(prevProps) {
			if (prevProps.genericPageQuery !== this.props.genericPageQuery) {
				this.loadRemainingNewsItems();
			}
		}

		componentWillUnmount() {
			this.unmounted = true;
		}

		async loadRemainingNewsItems() {
			const { genericPageQuery } = this.props;

			if (this.loadingRemainingNews || !shouldPaginateNewsItems(genericPageQuery)) {
				return;
			}

			this.loadingRemainingNews = true;

			try {
				await fetchAllNewsItemsPages(genericPageQuery);
			} catch (error) {
				if (!this.unmounted) {
					console.warn('Unable to fetch all Contentful news items for genericPageQuery.', error);
				}
			} finally {
				this.loadingRemainingNews = false;
			}
		}

		render() {
			return (
				<WrappedComponent
					{...this.props}
					genericPageQuery={filterPublicGenericPageWithNews(this.props.genericPageQuery)}
				/>
			);
		}
	};

	return withRouter(graphql(QUERY, {
		name: 'genericPageQuery',
		options: {
			variables: {
				newsSkip: 0,
				newsLimit: CONTENTFUL_NEWS_PAGE_SIZE,
			},
			notifyOnNetworkStatusChange: true,
		},
	})(HOC));
}
